<template>
  <section>
    <div class="dd-wall-card" style="text-align:center; padding: 32px;">
      <h2>404</h2>
      <p class="muted">Страница не найдена</p>
      <button class="btn" @click="$router.push('/wall/home')">На главную</button>
    </div>
  </section>
</template>

<script>
export default { name: 'WallNotFound' };
</script>

<style scoped>
.btn { background: var(--dd-accent); color: var(--dd-accent-contrast); border: none; padding: 10px 14px; border-radius: 6px; cursor: pointer; }
</style>
